import React from "react";
import styles from "./AuthenticatingGenesysDesktop.module.css";
import ContentWrapper from "../common/wrapper/ContentWrapper";
import ClearFix from "../common/ClearFix";

const AuthenticatingGenesysDesktop = props => {

    const {authState, onLoginFromPopup} = props; 

    const {loginUrl} = props;

    const onClickRefresh = () => {
        window.location.reload();
    }

    const handleLoginFromPopup = () => {
        if (onLoginFromPopup) onLoginFromPopup();
    }

    return (
    <ContentWrapper>
        <div className={styles.container}>
            <span className={styles.wrapper}>
                <div className={styles.spinner} />
                <p>Authstate: {authState}</p>
                <br/>
                <br/>
                <p>Please wait while the application is trying to authenticate</p>
            </span>
            <span className={styles.wrapper2}>
                <span style={{textAlign: "left"}}>
                    <p>You can monitor the login process on the left. <br/> In case the process results in an error, please follow the following procedure: </p>
                    <ol>
                        <li>Click the "Fix login" button</li>
                        <li>This will open a popup window</li>
                        <li>Complete the login procedure in the popup window</li>
                        <li>When complete, close the popup</li>
                        <li>Click the "Retry authentication" button</li>
                    </ol>
                </span>
                <div className={styles.buttonWrapper}>
                    {!!onLoginFromPopup && <button className={styles.enabled} onClick={handleLoginFromPopup}> 
                        Fix login
                    </button>}
                    <button className={styles.enabled} onClick={onClickRefresh} >
                        Retry authentication
                    </button>
                    <ClearFix />
                </div>
            </span>
            <span className={styles.wrapper3}>
                <iframe style={{width: "100%"}} src={loginUrl} />
            </span>
        </div>
    </ContentWrapper>
    )
}

export default AuthenticatingGenesysDesktop;